
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/cookie-policy",
      function () {
        return require("private-next-pages/en/cookie-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/cookie-policy"])
      });
    }
  